import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

export const IconMenuShoppingBag = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M14.6 3.6H12.8C12.8 1.611 11.189 0 9.2 0C7.211 0 5.6 1.611 5.6 3.6H3.8C2.81 3.6 2 4.41 2 5.4V16.2C2 17.19 2.81 18 3.8 18H14.6C15.59 18 16.4 17.19 16.4 16.2V5.4C16.4 4.41 15.59 3.6 14.6 3.6ZM9.2 1.8C10.19 1.8 11 2.61 11 3.6H7.4C7.4 2.61 8.21 1.8 9.2 1.8ZM14.6 16.2H3.8V5.4H5.6V7.2C5.6 7.695 6.005 8.1 6.5 8.1C6.995 8.1 7.4 7.695 7.4 7.2V5.4H11V7.2C11 7.695 11.405 8.1 11.9 8.1C12.395 8.1 12.8 7.695 12.8 7.2V5.4H14.6V16.2Z" fill="#AEB4BE"/>
        </SvgIcon>
    );
};